export function dateToHumanReadableString(date) {
    if (!date) {
        return ''
    }

    // Options for formatting the date
    const options = {
        weekday: 'long', // Display the full name of the weekday
        year: 'numeric',
        month: 'long', // Display the full name of the month
        day: 'numeric',
    }

    return new Date(date).toLocaleString('nl-NL', options)
}